angular.module('offlineChecker')
    .filter('propertyFilter', propertyFilter);

function propertyFilter() {
    return function (chosenProperty, properties) {
        var propName = '';
        angular.forEach(properties, function (property) {
            if (property.id === chosenProperty) {
                propName = property.name;
            }
        });
        return propName;
    }
}